/* @flow */
// TODO possible add this to @homeaway/react-image-carousel

import {trigger as edapTrigger} from './edapWrapper';

export const PROPERTY_CARD_CAROUSEL = 'search property card photo carousel';
export const MAP_CARD_CAROUSEL = 'search map property card photo carousel';
export const AMENITY_CAROUSEL = 'serp amenity carousel';
export const FLEX_DATES_CAROUSEL = 'serp flex dates carousel';

export const PHOTO_PREVIOUS = 'photo previous';
export const PHOTO_NEXT = 'photo next';

export type CarouselEdapCollectionType =
    | typeof PROPERTY_CARD_CAROUSEL
    | typeof MAP_CARD_CAROUSEL
    | typeof AMENITY_CAROUSEL
    | typeof FLEX_DATES_CAROUSEL;

export type CarouselEdapEventAction = typeof PHOTO_PREVIOUS | typeof PHOTO_NEXT;

export const MEDIA_INTERACTION = 'media.interaction';

export const triggerMediaInteractionEdapEvent = (
    collectionType: CarouselEdapCollectionType,
    eventAction: CarouselEdapEventAction,
    imageUri: string,
    imageIndex: number
) => {
    const mediaUuidRegexp = /([\w-]*)([^\/]*)$/;
    const mediaUuid = imageUri ? imageUri.match(mediaUuidRegexp) : '';

    edapTrigger(MEDIA_INTERACTION, {
        collectiontype: collectionType,
        eventaction: eventAction,
        mediaindex: `${imageIndex}`,
        mediatype: 'image',
        mediauuid: mediaUuid ? mediaUuid[1] : ''
    });
};
